import Constants from 'expo-constants';

import { LLM_SERVICE_BASE_URL } from '../config/config';
import { IS_LOCAL } from '../config/FruitfulEnvironment';

export const getLlmServiceHost = () => {
    // Allow for local development environment where the llm service is running on a different local network IP Address (e.g. making requests from iOS device to laptop all on same LAN).
    if (IS_LOCAL && Constants.expoConfig?.hostUri != null) {
        const hostIp = Constants.expoConfig.hostUri.split(`:`).shift();
        return `http://${hostIp}:4111`;
    } else {
        return LLM_SERVICE_BASE_URL;
    }
};
